// extracted by mini-css-extract-plugin
export var circle = "_ec-1";
export var exitConfirmationModal = "_ec-5";
export var iframe = "_ec-0";
export var offline = "_ec-3";
export var online = "_ec-2";
export var workstationSelectError = "_ec-4";